import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "leaflet/dist/leaflet.css";
import "./index.css";

import theme from "./theme";
import { AuthProvider } from "./components/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Borrowers from "./pages/Borrowers";
import BorrowerDetail from "./pages/BorrowerDetail";
import Collaterals from "./pages/Collaterals";
import CollateralDetail from "./pages/CollateralDetail";
import HazardMap from "./pages/HazardMap";
import Scenarios from "./pages/Scenarios";
import Origination from "./pages/Origination";
import Templates from "./pages/Templates";
import Reports from "./pages/Reports";
import Operations from "./pages/Operations";
import Vulnerability from "./pages/Vulnerability";
import BulkUpload from "./pages/BulkUpload";
import Mitigation from "./pages/Mitigation";
import Entities from "./pages/Entities";
import BoardReports from "./pages/BoardReports";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/borrowers" element={<ProtectedRoute><Borrowers /></ProtectedRoute>} />
            <Route path="/borrowers/:id" element={<ProtectedRoute><BorrowerDetail /></ProtectedRoute>} />
            <Route path="/collaterals" element={<ProtectedRoute><Collaterals /></ProtectedRoute>} />
            <Route path="/collaterals/:id" element={<ProtectedRoute><CollateralDetail /></ProtectedRoute>} />
            <Route path="/hazard-map" element={<ProtectedRoute><HazardMap /></ProtectedRoute>} />
            <Route path="/scenarios" element={<ProtectedRoute><Scenarios /></ProtectedRoute>} />
            <Route path="/origination" element={<ProtectedRoute><Origination /></ProtectedRoute>} />
            <Route path="/templates" element={<ProtectedRoute><Templates /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
            <Route path="/operations" element={<ProtectedRoute><Operations /></ProtectedRoute>} />
            <Route path="/vulnerability" element={<ProtectedRoute><Vulnerability /></ProtectedRoute>} />
            <Route path="/bulk-upload" element={<ProtectedRoute><BulkUpload /></ProtectedRoute>} />
            <Route path="/mitigation" element={<ProtectedRoute><Mitigation /></ProtectedRoute>} />
            <Route path="/entities" element={<ProtectedRoute><Entities /></ProtectedRoute>} />
            <Route path="/board-reports" element={<ProtectedRoute><BoardReports /></ProtectedRoute>} />

            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <ToastContainer position="bottom-right" autoClose={3500} hideProgressBar newestOnTop
        toastStyle={{ fontFamily: "IBM Plex Sans, sans-serif", fontSize: 13, borderRadius: 4 }} />
    </ThemeProvider>
  );
}

export default App;
